import * as React from 'react';
import { Bem, addClass } from '../../utils';
import { useId } from '../../utils/hooks/useId';
import './Icon.css';
const bem = Bem.create('vai-icon');
export function Icon({ name, color, size, className, onClick, htmlId, dataTa, style, ...rest }) {
    const id = useId(htmlId, ['icon']);
    const colorStyle = color ? { color } : undefined;
    const iconClass = addClass(bem.block(name, size), className);
    const iconStyle = colorStyle || style ? { ...style, ...colorStyle } : undefined;
    return React.createElement("span", Object.assign({ style: iconStyle, id: id.toString(), "data-ta": dataTa, className: iconClass, onClick: onClick }, rest));
}
//# sourceMappingURL=Icon.js.map